/**
 * Usage:
 *
 *   data-sw-top-nav-search - place on the container for the following elements:
 *
 *      data-sw-top-nav-search-type - place on the selector for search type
 *
 *      data-sw-top-nav-search-input - place on the input for searching
 *
 */

var $   = require('js/sw-jquery/sw-jquery');
var _ = require('underscore');

var SEARCH_TYPE_SELECTOR = '[data-sw-top-nav-search-type]';
var SEARCH_INPUT_SELECTOR = '[data-sw-top-nav-search-input]';
var SEARCH_INPUT_AUTOSUGGEST = '[data-sw-top-nav-search-auto-suggest]';
var SEARCH_TYPE_DATA_HREF = 'data-sw-href';
var SEARCH_TYPE_DATA_FORM_TYPE = 'data-sw-form-type';
var AUTOCOMPLETE_EXCLUDED_TYPES = ['shop', 'designer'];

module.exports = function ($fragment)
{
  $fragment.swFindWithSelf('.sw-search-form-js').each(function () {
    var $el = $(this);
    var $searchType = $el.find(SEARCH_TYPE_SELECTOR);
    var $searchInput = $el.find(SEARCH_INPUT_SELECTOR);
    var $searchInputAutosuggest = $el.find(SEARCH_INPUT_AUTOSUGGEST);
    var $searchFormType = $el.attr(SEARCH_TYPE_DATA_FORM_TYPE);

    // If autocomplete is not active, do nothing
    if ($searchFormType ==='desktop' && 
          ($searchType.length === 0 ||
           $searchInput.length === 0 ||
           $searchInputAutosuggest.length === 0
          )
        ) {
      return;
    }

    // Show or hide the autosuggest element based on the value of the type dropdown
    var toggleAutocomplete = function toggleAutocomplete($searchType) {
      if (_.contains(AUTOCOMPLETE_EXCLUDED_TYPES, $searchType.val())) {
        $searchInputAutosuggest.hide();
      } else {
        $searchInputAutosuggest.show();
      }
    };

    var setSearchFormAction = function setSearchFormAction(actionHref) {
      var $form = $($searchType[0].form);
      $form.attr('action', actionHref);
    };

    var updateSearchFormActionToSelectedOption = function updateSearchFormActionToSelectedOption() {
      var actionHref = $searchType.find(':selected').attr(SEARCH_TYPE_DATA_HREF);
      if (actionHref) {
        setSearchFormAction(actionHref);
      }
    };

    $searchType.change(function () {
      toggleAutocomplete($searchType);
      updateSearchFormActionToSelectedOption($searchType);
    });

    toggleAutocomplete($searchType);
  });
};
